<template>
  <div class="hyper-block-view">
    <div class="b">
      <div v-show="vers == 1" class="wrap">
        <div class="dis">
          <!-- <h1 class="h1">
            {{ $t('h1') }}
          </h1> -->
          <div class="chain-information">
            <div class="box">
              <div>
                <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('HyperchainSpaceHeight')} icon`">
                <span class="fl" v-text="$t('HyperchainSpaceHeight')"></span>
              </div>
              <div id="Hyperchain-height">
                <span class="fl"></span>
                <span class="fl cont" v-text="hyperchain_height"></span>
              </div>
              <div>
                <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('HyperchainSpaceHeight')} icon`">
                <span class="fl" v-text="$t('SpaceHeight')"></span>
              </div>
            </div>
            
            <div class="box">
              <div>
                <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Concurrency')} icon`">
                <span class="fl"  v-text="$t('Concurrency')"></span>
              </div>
              <div id="Blockchains">
                <span class="fl"></span>
                <span class="fl cont" v-text="blockchains"></span>
              </div>
              <div>
                <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Concurrency')} icon`">
                <span class="fl"  v-text="$t('Concurrency')"></span>
              </div>
            </div>
            <div class="box">
              <div>
                <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Nodes')} icon`">
                <span class="fl" v-text="$t('Nodes')"></span>
                <a class="fl a" href="https://www.hyperchain.net/static/hyperchainExplorer.html#/node_map"  v-text="$t('NodeMap')"></a>
                <!-- <a class="fl a" :href="`./nodemap.html?lang=${ $i18n.locale }`" v-text="$t('NodeMap')">节点地图</a> -->
              </div>
              <div id="Nodes">
                <span class="fl"></span>
                <span class="fl cont" v-text="nodes"></span>
              </div>
              <div>
                <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Nodes')} icon`">
                <a class="fl a" href="https://www.hyperchain.net/static/hyperchainExplorer.html#/node_map"  v-text="$t('Nodes')"></a>
                <!-- <a class="fl" href="https://www.hyperchain.net/test/static/hyperchainExplorer.html#/node_map"><img src="@/../public/static/img/blockView/Earth.png" alt=""></a> -->
                <!-- <a class="fl" :href="`./nodemap.html?lang=${ $i18n.locale }`"><img src="@/../public/static/img/blockView/Earth.png" alt=""></a> -->
              </div>
            </div>
            <div class="box">
              <div>
                <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Apps')} icon`">
                <span class="fl" v-text="$t('Apps')"></span>
              </div>
              <div id="Apps">
                <span class="fl"></span>
                <span class="fl cont" v-text="apps"></span>
              </div>
              <div>
                <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Apps')} icon`">
                <span class="fl"  v-text="$t('Apps')"></span>
              </div>
            </div>
          </div>
          <div ref="inputGroup" class="input-group clearfix">
            <span class="fl" style="color:#333" v-text="$t('Search')"></span>
            <input type="text" :placeholder="$t('SearchbyBlockIDTransactionID')" v-model="val" @keyup.enter="serch" @focus="$refs.inputGroup.className = 'input-group clearfix hoverInputBorderStyle';" @blur="$refs.inputGroup.className = 'input-group clearfix';"/>
            <button id="search-btn" @click="serch()"><img src="@/../public/static/img/blockView/search.png" alt="search"></button>
          </div>
          <div class="tips" v-text="$t('Tips')">
          </div>
          <div class="hint" :style="messageBol?'visibility:visible;':''">
            <img src="@/../public/static/img/blockView/iconHint.png" class="img"><span v-text="message"></span>
          </div>
        </div>
      </div>
      <div v-show="vers == 2" class="default">
        <img src="@/../public/static/images/default.png" alt="default"/>
      </div>
    </div>
    <div v-show="vers == 2" class="default_text">
      {{$t('mainnet_default')}}
    </div>
    <div v-show="vers == 1" class="wrap">
      <div class="dis">
        <div class="crumbs">
          <router-link v-show="$route.name == 'HyperblockView'||$route.name == 'LocalchainView'||$route.name == 'LocalblockView'" :to="`/`">
          {{$t('HyperBlockList')}}
          </router-link>
          <span v-show="$route.name == 'HyperblockView'||$route.name == 'LocalchainView'||$route.name == 'LocalblockView'">/</span>
          <router-link 
          v-show="$route.name == 'LocalchainView'||$route.name == 'LocalblockView'" 
          :to="`/HyperblockView/${ $route.params.hid }`"
          >{{$t('HyperBlockMsg')}}
          </router-link>
          <span v-show="$route.name == 'LocalchainView'||$route.name == 'LocalblockView'">/</span>
          <router-link v-show="$route.name == 'LocalblockView'" :to="`/LocalchainView/${ $route.params.hid }/${ $route.params.chainNum }`">
          {{$t('LocalChainMsg')}}
          </router-link>
          <span v-show="$route.name == 'LocalblockView'">/</span>
          <router-link v-show="($route.name == 'TxList' && $route.params.address) || $route.name == 'TxView'" :to="`/TxList`">
          Transactions
          </router-link>
          <span v-show="($route.name == 'TxList' && $route.params.address) || $route.name == 'TxView'">/</span>
        </div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data(){
    return {
      blockchains: 0,
      hyperchain_height: 0,
      nodes: 0,
      val: '',
      message: '搜索信息无效。',
      messageBol: false,
      vers: localStorage.getItem('vers') || 1,
      apps: 0,
    }
  },
  created(){
    this.init();
  },
  methods:{
    init(){
      var _this = this;
      _this.blockchains = 0;
      _this.hyperchain_height = 0;
      _this.nodes = 0;
      _this.$http({
        url:'hyperchain/info',
        baseURL: process.env.VUE_APP_CURRENTMODE,
        data: {net: _this.vers},
        method: 'get',
      }).then((res)=>{
        console.log()
        var data = res.data;
        if(data.ret == 200){
          _this.blockchains = data.data.blockchains;
          _this.hyperchain_height = data.data.hyperchain_height;
          _this.nodes = data.data.nodes;
          this.apps = data.data.apps
        }
      })
    },
    setVers(vers){
      let _this = this;
      _this.vers = vers;
      localStorage.setItem('vers',vers);
      _this.init();
    },
    serch(){
      this.messageBol = false;
      this.val = this.val.replace(/\[|\]|【|】| /g, "");
      if (this.val.length == 64) {
        this.$router.push(`/TxView/${ this.val }`);
        return;
      }

      if (this.val.length == 42 || (this.val.length <= 34 && this.val.length >= 27)) {
        this.$router.push(`/TxList/${ this.val }`);
        return;
      }      

      var lang = this.$i18n.locale;
      this.$http({
        url:`hyperchain/search?keyword=${ this.val }`,
        baseURL: process.env.VUE_APP_CURRENTMODE,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        console.log(data);
        if(data.ret == 200){
          this.messageBol = false;
          var dat = data.data;
          switch(dat.type){
            case "hyperblock":
              this.$router.push(`/HyperblockView/${ dat.hid }`);
            break;
            case "localchain":
              this.$router.push(`/LocalchainView/${ dat.hid }/${ dat.chain_num }`);
            break;
            case "localblock":
              this.$router.push(`/LocalblockView/${ dat.hid }/${ dat.chain_num }/${ dat.id }`);
            break;
            default:
              this.$router.push(`/`)
            break;
          }
        }else if(data.ret == 400001){
            this.messageBol = true;
            if(+this.val < this.hyperchain_height){
               if(lang == "zh"){
                  this.message = "数据暂未找到，已请求数据同步，请稍后重试";
               }else{
                  this.message = "Data not found,  synchronization request sent, please try later.";
               }
            }else{
               if(lang == "zh"){
                  this.message = "查询的超块还未生成";
               }else{
                  this.message = "Queried  Hyperblock have not been generated";
               }
            }
         }else if(data.ret == 400002){
            this.messageBol = true;
            if(lang == "zh"){
               console.log(2)
               this.message = "子链信息未找到";
            }else{
               this.message = "Subchain information not found";
            }
         }else if(data.ret == 400003){
            this.messageBol = true;
            if(lang == "zh"){
               console.log(3)
               this.message = "子链区块信息未找到";
            }else{
               this.message = "Subchain block information not found";
            }
         }else if(data.ret == 400004){
            this.messageBol = true;
            if(lang == "zh"){
               console.log(4)
               this.message = "搜索信息无效。";
            }else{
               this.message = "invalid input.";
            }
         }
      })
    }
  }
}
</script>
<style lang="scss" src="./../../public/static/scss/HyperblockView.scss"></style>
<style scoped lang="scss">

  input::-webkit-input-placeholder {
    color: #ced4d9;
    font-size: 14px;
  }
  .b{
    background: #57687D;
  }
  .phone{
    display: none;
  }
  .hoverInputBorderStyle {
    border-color: #e37200;
  }
  .default{
    text-align: center;
    img{
      margin: 60px auto -130px;
    }
  }
  .default_text{
    color: #4b5666;
    font-size: 30px;
    text-align: center;
    opacity: .6;
    margin-top: 160px;
    margin-bottom: 100px;
  }
  .crumbs{
    margin: 20px 0;
    font-size: 14px;
    color: #888888;
    span{
      margin: 0 6px;
    }
    a{
      color: #888888;
      &:hover{
        color: #e37200;
        text-decoration: underline;
      }
    }
  }
  @media screen and (max-width: 768px) {

    .phone{
      display: inline;
    }
    .crumbs{
      font-size: .28rem;        
    }
    .default{
      text-align: center;
      img{
        margin: .60rem auto -1.30rem;
        width: 2.76rem;
        height: 2.86rem;
      }
    }
    .default_text{
      color: #4b5666;
      font-size: .36rem;
      text-align: center;
      opacity: .6;
      margin-top: 1.60rem;
    }
  }
  
</style>

